import {FC} from 'react'
import {simpleCurrency} from 'app/format/currency'
import {KTSVG} from '_metronic/helpers'

type Props = {
  checkout: any
}

const CustomerDeliveryMethod: FC<Props> = ({checkout}) => {
  if (checkout && checkout.shippingRate) {
    const {shippingRate} = checkout
    return (
      <div className='alert alert-dismissible bg-light-primary border border-primary d-flex flex-column flex-sm-row p-5 mb-10'>
        <span className='svg-icon svg-icon-2hx svg-icon-primary me-4 mb-5 mb-sm-0'>
          <KTSVG path='/media/icons/duotune/general/gen045.svg' />
        </span>
        <div className='d-flex align-items-center'>
          <h5 className='mb-1'>
            The customer paid {simpleCurrency(shippingRate.price)} for {shippingRate.title}
          </h5>
        </div>
      </div>
    )
  }
  return null
}

export default CustomerDeliveryMethod
